import styled, { css } from 'styled-components'

export const StyledExchangeBtn = styled.button<{ disabled?: boolean, isInIframe?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background: ${({ disabled, theme }) =>
    disabled ? theme.colors.primaryDisabled : theme.colors.primary};
  display: flex;
  justify-content: center;
  border-radius: 48px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 12px 0;
  width: 100%;
  margin-top: 20px;
  ${({ isInIframe, disabled }) =>
    isInIframe &&
    disabled &&
    css`
      border: 2px solid transparent;
      background-image:
        /* background  */
        radial-gradient(circle at 87.5% 105.21%, #0cc5ff 0%, #007fff 100%),
        /* border */
        linear-gradient(to bottom right,
          #ffffff80,
          #318fef12 29%,
          #0cc5ff12 100%),
        /* background under border */
        radial-gradient(circle at 87.5% 105.21%, #0cc5ff 0%, #007fff 100%);
      background-clip: padding-box, border-box, border-box;
      background-origin: padding-box, border-box, border-box;
      box-shadow: 2px 2px 20px 6px rgba(0, 127, 255, 0.04);
      backdrop-filter: blur(8px);
      opacity: 0.5;
      cursor: not-allowed;
    `}
`
